/**
 * @description Routes, types et constantes pour YKE Multi_Services
 * © 2026 YKE Multi_Services - Votre partenaire de prestige
 */

import { ImageKey } from "@/assets/images";

/**
 * Chemins de navigation de l'application
 */
export const ROUTE_PATHS = {
  HOME: "/",
  SERVICES: "/services",
  ABOUT: "/a-propos",
  CONTACT: "/contact",
} as const;

/**
 * Interface définissant un service proposé par YKE Multi_Services
 */
export interface Service {
  id: string;
  title: string;
  description: string;
  fullDescription: string;
  imageKey: ImageKey;
  category: "wine" | "residence" | "land";
  features: string[];
  locations?: string[];
}

/**
 * Interface pour les informations de contact de l'entreprise
 */
export interface ContactInfo {
  companyName: string;
  phone1: string;
  phone2: string;
  email: string;
  address: string;
  city: string;
  slogan: string;
  openingHours: string;
}

/**
 * Données de contact officielles de YKE Multi_Services
 */
export const CONTACT_INFO: ContactInfo = {
  companyName: "YKE Multi_Services",
  phone1: "07 58 56 77 94",
  phone2: "27 21 72 91 54",
  email: "YKE_Multi_Service@Proton.me",
  address: "SIPIM Port-Bouët",
  city: "Abidjan, Côte d'Ivoire",
  slogan: "Votre partenaire de prestige",
  openingHours: "Lun - Ven: 08:00 - 18:00 | Sam: 09:00 - 13:00",
};

/**
 * Types utilitaires pour les catégories de services
 */
export type ServiceCategory = Service["category"];
